import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Selector from '../../common/custom-selector';
import {
  ALL,
  CONVERSATION,
  CONVERSATION_SDK,
  DISCOVER,
  FEED,
  INDEPENDENT,
  INDEPENDENT_HP,
  INDEPENDENT_SDK,
  PITC,
  PITC_AMP,
  PITC_DOUBLE_DECKER,
  PITC_HOMEPAGE,
  REACTIONS,
  RECIRCULATION,
  SPOTLIGHT,
  TOPIC_TRACKER
} from '../../../models/source-types';
import Icon from 'utils/components/icon';

const displayNames = {
  [ALL]: 'All Sources',
  [CONVERSATION]: 'Conversation',
  [CONVERSATION_SDK]: 'Conversation SDK',
  [DISCOVER]: 'Discover',
  [FEED]: 'Feed',
  [INDEPENDENT]: 'Standalone Ads',
  [INDEPENDENT_HP]: 'Standalone Ads Homepage',
  [INDEPENDENT_SDK]: 'Standalone Ads SDK',
  [PITC_DOUBLE_DECKER]: 'More Conversations for You',
  [PITC]: 'Popular in the Community',
  [PITC_AMP]: 'Popular in the Community AMP',
  [PITC_HOMEPAGE]: 'Popular in the Community Homepage',
  [REACTIONS]: 'Reactions',
  [RECIRCULATION]: 'Recirculation',
  [SPOTLIGHT]: 'Spotlight',
  [TOPIC_TRACKER]: 'Topic Tracker'
};

class SourceSelector extends Component {
  changeSource(value) {
    var {
      pageInfo: { source },
      onFiltersChange
    } = this.props;
    if (value !== source) {
      if (this.refs.selector) {
        this.refs.selector.hide();
      }
      onFiltersChange({ source: value });
    }
  }

  isChecked(source) {
    return this.props.pageInfo.source === source ? 'checked' : '';
  }

  getItems() {
    return [
      ALL,
      RECIRCULATION,
      INDEPENDENT,
      INDEPENDENT_HP,
      INDEPENDENT_SDK,
      CONVERSATION,
      CONVERSATION_SDK,
      DISCOVER,
      REACTIONS,
      PITC,
      PITC_AMP,
      FEED,
      SPOTLIGHT,
      PITC_DOUBLE_DECKER,
      PITC_HOMEPAGE,
      TOPIC_TRACKER
    ].map(source => ({
      value: source,
      element: (
        <div onClick={this.changeSource.bind(this, source)}>
          {displayNames[source]}
          {this.isChecked(source) && <Icon className="checked-icon" name="validation-success" />}
        </div>
      )
    }));
  }

  render() {
    const {
      pageInfo: { source }
    } = this.props;
    const items = this.getItems();
    return (
      <div style={{ marginLeft: '15px' }}>
        <Selector ref="selector" items={items} selected={source} width={275} />
      </div>
    );
  }
}

SourceSelector.displayName = 'SourceSelector';

SourceSelector.propTypes = {
  pageInfo: PropTypes.object.isRequired,
  onFiltersChange: PropTypes.func
};

export default SourceSelector;
